<template>
  <div class="subnav">
    <router-link v-if="item.right" :key="item.route" v-for="item in routeList" class="link"
      :to="{ name: item.route, params: { project_id: projectId } }">{{ item.name }}
    </router-link>
  </div>
</template>
<script>
export default {
  props: ['routeList', 'projectId']
}
</script>
<style scoped lang="scss">
.subnav {
  margin: 0 -20px 0 -10px;
  padding: 0 12px;
  box-shadow: 0 5px 12px -3px rgba(221, 222, 225, 0.5);
  white-space: nowrap;
  text-align: center;

  .link {
    font-size: 14px;
    margin: 0 20px;
    color: #495060;
    line-height: 40px;
    height: 40px;
    cursor: pointer;
    text-decoration: none;
  }


  .link.router-link-active {
        background-color: #e8f0f9; /* Light blue background instead of yellow */
        color: #3a6ea5; /* Blue text color */
        border-radius: 10px;
    }

}
</style>
